export const colors = {
  brand: {
    50: '#ffe5f1',
    100: '#ffcce4',
    150: '#F7FAFC',
    200: '#ffb3d7',
    300: '#ff99ca',
    400: '#ff80bd',
    500: '#FF5CAA',
    600: '#ff4da3',
    700: '#ff3396',
    800: '#ff1a88',
    900: '#5d1738',
  },
  primary: '#b34093',
  secondary: '#ffd6f4',
  highlight: '#b9ff5c',
  success: '#82b340',
  default: 'white',
  white: '#ffffff',
  black: '#000000',
  darkGrey: '#b3b7bd',
  secondaryDark: '#4A5568',
  tetiaryGray: '#E2E8F0',
  primaryPink: '#E53E3E',
  tetiaryDark: '#1A202C',
  primaryGray: '#718096',
  davyGray: '#51565F',
  electricPink: '#f11a82',
  taupeGray: '#898787',
  mediumGreen: '#38A169',
  dewGray: '#F0FFF4',
  tangRed: '#DD6B20',
  dazBlue: '#385C8A',
  denceGray: '#495a68',
  metalGray: '#667085',
  rosePink: '#FF5DAA',
}
